import { useEffect } from 'react';
// import { loginUser } from '../features/user/userSlice';
import FormRow from '../components/FormRow';
import { useGlobalContext } from '../context/GlobalContext';
import sha256 from 'crypto-js/sha256';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
// gunz pw
// gitte password

const Login = () => {
  const { setUser, loginUser, user, isLoading } = useGlobalContext();

  // dynamic updating the input field corresponding to the correct input
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setUser({ ...user, [name]: value }); // square brackets on name = e.target.name to not make this hard coded 'name'
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!user.email || !user.password) {
      console.log('Please fill out all fields');
    }
    if (!user.isLoggedIn) {
      const sha256Password = sha256(user.password);
      console.log(sha256Password);

      setUser({ ...user, password: sha256Password });

      loginUser({ user });
    } else {
      setUser({});
    }
  };

  const toggleMember = () => {
    setUser({ ...user, isMember: !user.isMember });
  };
  useEffect(() => {
    if (user) {
      setTimeout(() => {
        //navigate('/');
      }, 2000);
    }
  }, [user]);

  return (
    <LoginContainer className='full-page'>
      <form className='form' onSubmit={onSubmit}>
        <h3>Login</h3>
        <div>{user ? <h2>{user.name}</h2> : <h2>No user found</h2>}</div>
        {/* email field */}
        <FormRow
          type='email'
          name='email'
          value={user.email}
          handleChange={handleChange}
        />
        {/* password field */}
        <FormRow
          type='password'
          name='password'
          value={user.password}
          handleChange={handleChange}
        />
        <button type='submit' className='btn btn-block' disabled={isLoading}>
          {isLoading ? 'loading...' : 'submit'}
        </button>
        <p>
          Not a member yet?
          <button type='button' onClick={toggleMember} className='member-btn'>
            <Link to='/register'>Register</Link>
          </button>
        </p>
      </form>
    </LoginContainer>
  );
};
export default Login;

const LoginContainer = styled.section`
  display: grid;
  align-items: center;
  .logo {
    display: block;
    margin: 0 auto;
    margin-bottom: 1.38rem;
  }
  .form {
    max-width: 400px;
    border-top: 5px solid var(--primary-500);
  }
  h3 {
    text-align: center;
  }
  p {
    margin: 0;
    margin-top: 1rem;
    text-align: center;
  }
  .btn {
    margin-top: 1rem;
  }
  .member-btn {
    background: transparent;
    border: transparent;
    color: var(--primary-500);
    cursor: pointer;
    letter-spacing: var(--letterSpacing);
  }
`;
